pageId = "teams-collections-index"
page = "##{ pageId }"

$ ->
  $(document)
    .on("ajax:success", "#{ page } .collection-action", (e, result) ->
      if result.success
        card = $(@).closest(".collection")

        card.fadeOut("fast", ->
          this.remove()

          unless $(".collection").length
            $(".init-collections-empty").show()
        )
    )

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-me').addClass('active') if $page.data('self')

  unless $(".collection").length
    $(".init-collections-empty").show()

  tower.workStatus()
